/**
 * File: WizardController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class WizardController {
    // @ngInject
    constructor($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $mdDialog, TPCONSTANT) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => {}

        let userId = localStorageService.get("user_id")
        let authoring = localStorageService.get("authoringData")
        let planId = $state.params.planId;
        let note = {}

        let GET_PLAN = TPWIZARDCONSTANT.API_GET_TP + planId + "/" + userId

        let RESOURCES_LABEL = TPWIZARDCONSTANT.RESOURCES_LABEL;
        let RESOURCE_IMAGE = TPWIZARDCONSTANT.RESOURCES_IMG;

        $scope.wizardItems = [];
        $scope.isViewMode = false;
        let reportId = "reports"
        $scope.approveMode = false


        $scope.isResourceCompleted = () => {
            let currentResource = $scope.currentResource
            if (currentResource) {
                if (currentResource.type === "activityForm") {
                    if (currentResource.status === "conducted" || currentResource.status === "published") {
                        var alert = $mdDialog.alert()
                            .textContent(currentResource.title + ' is ' + currentResource.status + '.' + ' So you cannot edit it')
                            .clickOutsideToClose(true)
                            .ok('Ok');
                        $mdDialog.show(alert);
                        return true
                    } else {
                        return false
                    }
                }
                if (currentResource.isComplete) {
                    var alert = $mdDialog.alert()
                        .textContent(currentResource.title + ' is completed. So you cannot edit it')
                        .clickOutsideToClose(true)
                        .ok('Ok');
                    $mdDialog.show(alert);
                    return true
                } else {
                    return false
                }
            }
        }

        var setResource = () => {
            let stateName = $scope.currentResource.type;
            let _id = $scope.currentResource._id;
            if ($scope.isViewMode) {
                stateName = stateName + "Preview";
            }
            if (stateName !== "reports") {
                $state.go(stateName, {
                    resourceId: _id
                })
            }
        }

        $scope.gotoEditMode = () => {
            if (!$scope.isResourceCompleted()) {
                localStorageService.set("viewMode", false)
                $scope.isViewMode = false
                setResource()
                authService.callAPI(GET_PLAN, "GET", {}, setWizard)
            }
        }

        $scope.gotoViewMode = () => {
            localStorageService.set("viewMode", true)
            $scope.isViewMode = true
            setResource()
            authService.callAPI(GET_PLAN, "GET", {}, setWizard)
        }

        $rootScope.setStatus = (itemId, status) => {
            _.each($scope.wizardItems, function(resource) {
                if (resource._id == itemId)
                    resource.status = status
            })
            setStatus(status)
        }

        /*
         * To set boolean values based on resource status
         * 
         * @status : String - status of the resources
         * 
         * @return : null
         */
        var setStatus = (status) => {
            if (!status) {
                $scope.isCreated = false;
                $scope.isSentforApproval = false;
                $scope.isStatusAdded = false;
                $scope.isApproved = false;
            } else {
                switch (status) {
                    case TPWIZARDCONSTANT.STATUS_CREATED:
                        $scope.isCreated = true;
                        $scope.isSentforApproval = false;
                        $scope.isStatusAdded = false;
                        $scope.isApproved = false;
                        break;
                    case TPWIZARDCONSTANT.STATUS_SENT_FOR_APPROVAL:
                        $scope.isSentforApproval = true;
                        $scope.isStatusAdded = false;
                        $scope.isCreated = false;
                        $scope.isApproved = false
                        break;
                    case TPWIZARDCONSTANT.STATUS_APPROVED:
                        $scope.isCreated = false;
                        $scope.isSentforApproval = false;
                        $scope.isApproved = true;
                        $scope.isStatusAdded = true;
                        $scope.preetyStatus = 'Approved';
                        break;
                    case TPWIZARDCONSTANT.STATUS_REJECTED:
                        $scope.isCreated = false;
                        $scope.isSentforApproval = false;
                        $scope.isApproved = false;
                        $scope.isStatusAdded = true;
                        $scope.preetyStatus = 'Rejected';
                        break;
                    case TPWIZARDCONSTANT.STATUS_CONDUCTED:
                        $scope.isCreated = false;
                        $scope.isSentforApproval = false;
                        $scope.isApproved = true;
                        $scope.isStatusAdded = true;
                        $scope.preetyStatus = 'Approved';
                        break;
                }
            }
        }

        var itemClicked = (clickedResource) => {
            $scope.writeNote = false;
            $scope.isSubmitApproval = false;
            $scope.isUserAssigned = false;
            $scope.isSentforApproval = false;
            $scope.isReport = false;
            $scope.isActivityConducted = false;
            $scope.toShare = false

            //Boolean - To show complete button when the Teaching plan is approved
            $scope.isShowComplete = false

            //Boolean - To show Teaching plan completed status
            $scope.isCompleted = false

            if (clickedResource.type === "reports") {
                $scope.isReport = true;
            }
            if ((clickedResource.type != "reports") && (clickedResource.type != "activityForm")) {
                $scope.toShare = true;
            }
            $scope.currentResource = clickedResource;
            $scope.currentStatus = clickedResource.status
            setStatus(clickedResource.status);
            note.resource = {
                '_id': clickedResource._id,
                'title': clickedResource.title,
                'type': clickedResource.type,
                'mode': $scope.isViewMode
            }
            if (clickedResource.type == "activityForm") {
                $scope.isPractice = clickedResource.isPractice;
                $scope.isActivityConducted = false;
            }

            //to check whether the resources has assigned users or not
            if (clickedResource.assign_users && clickedResource.assign_users.list && clickedResource.assign_users.list.length > 0) {
                $scope.isUserAssigned = true;
                let status = TPWIZARDCONSTANT.STATUS_APPROVED;
                if (clickedResource.type == "activityForm")
                    status = TPWIZARDCONSTANT.STATUS_CONDUCTED;
                if (clickedResource.status && clickedResource.status === status) {
                    if (clickedResource === TPWIZARDCONSTANT.STATUS_CONDUCTED)
                        $scope.isActivityConducted = true
                    if (clickedResource.isComplete) {
                        $scope.isShowComplete = false
                        $scope.isCompleted = true
                    } else {
                        $scope.isCompleted = false
                        $scope.isShowComplete = true
                    }
                }
            }
            _.each($scope.wizardItems, function(item) {
                if (item._id === clickedResource._id) {
                    item.active = true
                } else {
                    item.active = false
                }
            })
            setResource()
        }

        $scope.clicked = (clickedResource) => {
            if (clickedResource) {
                if (clickedResource._id === reportId) {
                    itemClicked(clickedResource)
                } else {
                    if ($scope.isViewMode !== true) {
                        if (!$scope.isResourceCompleted(clickedResource)) {
                            itemClicked(clickedResource)
                        }
                    } else {
                        itemClicked(clickedResource)
                    }
                }
            }
        }

        function addResources(each) {
            let visited = false;
            let active = false;
            if (each.type) {
                if ($state.params.resource && $state.params.resource == each._id) {
                    $scope.currentStatus = each.status
                    setStatus(each.status)
                    if (each.assign_users && each.assign_users.list && each.assign_users.list.length > 0) {
                        $scope.isUserAssigned = true;
                        let status = TPWIZARDCONSTANT.STATUS_APPROVED;
                        if (each.type == "activityForm" && !each.isPractice)
                            status = TPWIZARDCONSTANT.STATUS_CONDUCTED;
                        if (each.status && each.status === status) {
                            if (each.status === TPWIZARDCONSTANT.STATUS_CONDUCTED)
                                $scope.isActivityConducted = true
                            if (each.isComplete) {
                                $scope.isShowComplete = false
                                $scope.isCompleted = true
                            } else {
                                $scope.isCompleted = false
                                $scope.isShowComplete = true
                            }
                        }
                    }
                    if ((each.type != "reports") && (each.type != "activityForm")) {
                        $scope.toShare = true;
                    }

                    active = true
                }
                if (each.status) {
                    visited = true
                }

                let obj = each;
                obj.name = RESOURCES_LABEL[each.type];
                obj.caption = RESOURCES_LABEL[each.type] + "-" + each.title;
                obj.imgUrl = RESOURCE_IMAGE[each.type]
                obj.visited = visited;
                obj.active = active;
                obj.direction = "left";
                if ($scope.wizardItems.findIndex(i => i._id === obj._id) === -1)
                    $scope.wizardItems.push(obj)
            }
        }

        var setWizard = (response) => {
            if (response && response.result && response.result.data) {
                let tp = response.result.data;
                localStorageService.set("currentPlan", tp)
                $scope.planTilte = tp.title;
                $scope.themeTitle = tp.theme_title
                note = {
                    'academics': {
                        'session_id': tp.session_id,
                        'curriculum_id': tp.curriculum_id,
                        'class_id': tp.class_id,
                        'batch_id': tp.batch_id,
                        'subject_id': tp.subject_id,
                        'school_id': tp.school_id
                    },
                    'teaching_plan': {
                        '_id': tp._id,
                        'title': tp.title
                    },
                    'theme': {
                        '_id': tp.theme_id,
                        'title': tp.theme_title
                    },
                    'academic_year': tp.academic_year
                }
                if (tp.teacher_id === userId) {
                    $scope.isCreator = true;
                }
                if (tp.status === 'draft') {
                    $scope.isDraft = true
                }
                let resources = tp.resources;
                let assignedResources = tp.assign_resources
                if (resources && resources.length > 0) {
                    _.each(resources, function(each) {
                        if ($scope.wizardUserPrivilege.approveResource && $scope.wizardUserPrivilege.approveResource.create) {
                            let resIds = localStorageService.get("approverResourceIds")
                            if (resIds && resIds.length > 0) {
                                $scope.isApprover = true;
                                _.each(resIds, function(ob) {
                                    if (each._id === ob) {
                                        $scope.isResourceExist = true
                                        addResources(each)
                                    }
                                })
                            }
                        }
                        if ($scope.wizardUserPrivilege.shareContent && $scope.wizardUserPrivilege.shareContent.read) {
                            if (each.status === 'approved') {
                                // Display teaching plan to shared parents only
                                if (each.shared_parents) {
                                    _.each(each.shared_parents, function(eachUser) {
                                        if (eachUser.parent_id === userId) {
                                            addResources(each)
                                        }
                                    })

                                }
                            }
                        }
                        if ($scope.wizardUserPrivilege.studentPreview && $scope.wizardUserPrivilege.studentPreview.read) {
                            if (_.contains(assignedResources, each._id)) {
                                addResources(each)
                            }
                        }
                        if ($scope.wizardUserPrivilege.enableToggleView && $scope.wizardUserPrivilege.enableToggleView.edit && $scope.isCreator) {
                            addResources(each)
                        }
                    })
                    if ($scope.isViewMode && !$scope.approveMode) {
                        let report = {
                            _id: reportId,
                            name: reportId,
                            type: "reports",
                            visited: false,
                            active: false,
                            direction: "left",
                            imgUrl: "../../../../../img/report_card.png",
                            caption: "Report"
                        }
                        if ($scope.wizardItems.length > 0) {
                            let reportItem = $scope.wizardItems[$scope.wizardItems.length - 1]
                            if (reportItem._id !== reportId) {
                                $scope.wizardItems.push(report)
                            }
                        }
                    } else {
                        $scope.wizardItems = $scope.wizardItems.filter(function(elem) {
                            return elem.type !== "reports"
                        })
                    }
                    if ($state.params.resourceId) {
                        let clickedResource;
                        _.each($scope.wizardItems, function(item) {
                            if (item._id === $state.params.resourceId) {
                                clickedResource = item
                            }
                        })
                        $scope.clicked(clickedResource)
                    } else {
                        $scope.clicked($scope.wizardItems[0])
                    }

                }
            }
        }

        // UserPrivilages.getUserPrivilageInitialSetting(function () {
        // let wizardUserAccess = UserPrivilages.getFeatures('wizard');
        // let noteUserAccess = UserPrivilages.getFeatures('viewnote');
        let wizardUserAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "wizard"
        })
        let noteUserAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "viewnote"
        })
        $scope.wizardUserPrivilege = {};
        $scope.noteUserPrivilege = {};
        if (wizardUserAccess.length > 0) {
            _.each(wizardUserAccess, function(wizardObj) {
                let user_access = {};
                _.each(wizardObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.wizardUserPrivilege[wizardObj.feature_id] = user_access;
            })
            if (noteUserAccess.length > 0) {
                _.each(noteUserAccess, function(noteObj) {
                    let user_access = {};
                    _.each(noteObj.privilege, function(privObj) {
                        user_access[privObj.name.toLowerCase()] = privObj.status
                    })
                    $scope.noteUserPrivilege[noteObj.feature_id] = user_access;
                })
            }
            if ($scope.wizardUserPrivilege.approveResource && $scope.wizardUserPrivilege.approveResource.create) {
                if (!localStorageService.get("viewMode"))
                    $scope.isViewMode = false
                else
                    $scope.isViewMode = true
                $scope.approveMode = true
            }
            if ($scope.wizardUserPrivilege.studentPreview && $scope.wizardUserPrivilege.studentPreview.read) {
                $scope.isViewMode = true
            }
            authService.callAPI(GET_PLAN, "GET", {}, setWizard)
        }

        // Added by: Raziya
        // Assign users - start
        $scope.showAssignUser = () => {
                if ($scope.isUserAssigned) {
                    var confirm = $mdDialog.confirm()
                        .textContent('It will reassign previously assigned students')
                        .ok('Ok')
                        .cancel('Cancel');
                    $mdDialog.show(confirm).then(function() {
                        $state.go('assignUsers', {
                            planId: $state.params.planId,
                            previousState: {
                                state: $state.current.name,
                                params: {
                                    'planId': $state.params.planId,
                                    resourceId: $state.params.resourceId
                                }
                            }
                        })
                    }, function() {});
                } else {
                    $state.go('assignUsers', {
                        planId: $state.params.planId,
                        previousState: {
                            state: $state.current.name,
                            params: {
                                'planId': $state.params.planId,
                                resourceId: $state.params.resourceId
                            }
                        }
                    })
                }
            }
            // Added by: Raziya
            //   Assign users - end

        // Added by: Raziya
        // To get approver list  - start
        let isCurrentApprover = false;
        let academics = {
            session_id: authoring.session_id,
            curriculum_id: authoring.curriculum_id,
            class_id: authoring.class_id,
            batch_id: authoring.batch_id,
            subject_id: authoring.subject_id,
            school_id: authoring.school_id
        }
        authService.callAPI(TPCONSTANT.API_TP_APPROVERS, "POST", academics, function(response) {
                if (response.result && response.result.data && response.result.data.data) {
                    let resultData = response.result.data.data
                    if (resultData && resultData.length > 0 && resultData[0].roles)
                        $scope.approverRoles = resultData[0].roles
                    $scope.$apply()
                } else {}
            })
            // Added by: Raziya
            //   To get approver list  - end

        //to filter person dropdown based on role
        $scope.filterPerson = () => {
            // let approverList = _.filter($scope.approverRoles, function(person) {
            //     return person._id.indexOf($scope.approverRole) !== -1;
            // })
            let approverList = _.filter($scope.approverRoles, function(person) {
                 return person._id == $scope.approverRole
            })
            if (approverList && approverList.length > 0)
                $scope.approverRolePersons = approverList[0].users
        }

        // Added by: Raziya
        // send for approval  - start
        // to show dropdown for selecting role and user for approval process
        $scope.submitforApprovalClick = () => {

            $scope.isSubmitApproval = true

        }

        // Added by: Raziya
        //   send for approval - start
        $scope.submitforApproval = () => {
            $scope.isLoading = true
            let resId = []
            if (!$scope.approverRole) {
                $scope.approverRoleError = "Select a role"
            }
            if (!$scope.approverPerson) {
                $scope.approverPersonError = "Select a person"
            }
            if ($scope.approverRole && $scope.approverPerson) {
                let approverId = $scope.approverPerson;
                if ($scope.currentResource)
                    resId.push($scope.currentResource._id)
                $scope.isSubmitApproval = false;
                let academics = {
                    session_id: authoring.session_id,
                    curriculum_id: authoring.curriculum_id,
                    class_id: authoring.class_id,
                    batch_id: authoring.batch_id,
                    subject_id: authoring.subject_id,
                    school_id: authoring.school_id,
                    session: authoring.session,
                    curriculum: authoring.curriculum,
                    class: authoring.class,
                    batch: authoring.batch,
                    subject: authoring.subject,
                    tp_id: planId,
                    res_ids: resId,
                    user_id: userId,
                    approver_id: approverId,
                    approver_role: $scope.approverRole,
                    is_tp_approval: false
                }
                authService.callAPI(TPCONSTANT.API_SEND_FOR_APPROVAL, "POST", academics, function(response) {
                    if (response.result) {
                        $scope.isSentforApproval =true
                        $scope.isLoading = false
                        toastr.success("Successfully send for approval") 
                        console.log(response)
                    } else {
                        $scope.isLoading = false
                        console.log(response.error)
                    }
                    _.defer(function() { $scope.$apply(); });
                })
            }
        }

        $scope.cancelApproval = () => {
            $scope.isSubmitApproval = false;
        }

        // Added by: Raziya
        //   To approve or reject resources - start
        $scope.setResourceStatus = function(status) {
                let approveStatus = status
                let isActivity = false
                let currentResource = $scope.currentResource;
                if (currentResource.type === 'activityForm') {
                    isActivity = true
                }
                let resId
                if ($scope.currentResource)
                    resId = $scope.currentResource._id
                let academics = {
                    session_id: authoring.session_id,
                    curriculum_id: authoring.curriculum_id,
                    class_id: authoring.class_id,
                    batch_id: authoring.batch_id,
                    subject_id: authoring.subject_id,
                    school_id: authoring.school_id,
                    tp_id: planId,
                    res_id: resId,
                    user_id: userId,
                    is_activity: isActivity,
                    res_status: approveStatus
                }
                authService.callAPI(TPWIZARDCONSTANT.API_APPROVE_RESOURCE, "POST", academics, function(response) {
                    if (response.result) {
                        if (approveStatus === 'approved') {
                            setStatus(approveStatus)
                            toastr.success("Approved Successfully")
                        } else {
                            setStatus(approveStatus)
                            toastr.error('Rejected')
                        }
                        console.log(response)
                    } else {
                        console.log(response.error)
                    }
                })
            }
            /*Added by: Raziya
              To approve or reject resources - end*/

        //To add notes
        $scope.addNote = () => {
            $scope.userNotes = ""
            var data = {
                user_id: userId,
                plan_id: planId,
                theme_id: note.theme._id,
                resource_id: $scope.currentResource ? $scope.currentResource._id : null,
                academic_year: authoring.academic_year
            }
            authService.callAPI(TPWIZARDCONSTANT.API_GET_PREV_NOTES, "POST", data, (response) => {
                if (response && response.result && response.result.data) {
                    $scope.prevNote = response.result.data.note
                    $scope.userNotes = response.result.data.note
                    $scope.writeNote = true;
                } else {
                    $scope.writeNote = true;
                }
                _.delay(() => {
                    $scope.$apply()
                })
            })
        }

        //To close notes
        $scope.closeNote = () => {
                $scope.writeNote = false;
                if ($scope.userNotes && $scope.prevNote !== $scope.userNotes) {
                    var data = {
                        noteObj: note,
                        userId: userId,
                        noteVal: $scope.userNotes,
                        toArchive: $scope.toArchive
                    }
                    authService.callAPI(TPWIZARDCONSTANT.API_ADD_NOTES, "POST", data, (response) => {
                        if (response.result.data) {
                            toastr.success("Notes added successfully")
                        }
                    })
                }

            }
            /*
             * To set complete status for Resources
             * 
             * @planId : Teaching plan id
             *
             * @return : null
             */

        $scope.setCompleteStatus = function() {
            let planId = $state.params.planId;
            let resId = $scope.currentResource._id
            authService.callAPI(TPWIZARDCONSTANT.API_COMPLETE_RESOURCE + planId + '/' + resId, "GET", {}, function(response) {
                if (response) {
                    console.log(response)
                    $scope.isShowComplete = false
                    $scope.isCompleted = true
                    toastr.success("Updated complete status")
                    $scope.$apply()
                } else {
                    toastr.error("Network Error, please try later.")
                }
            })
            $scope.isShowComplete = false
            $scope.isCompleted = true
        }
    };
}

export default WizardController;



// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/wizard.js